import { QueryField } from '@procureai/query-builder-ui-mui';

export const queryFieldFactory =
  (t: (key: string) => string, { i18nPrefix }: { i18nPrefix: string }) =>
  (field: QueryField): QueryField => ({
    ...field,
    label: t(`${i18nPrefix}.filters.${field.name}`),
    grp: t(`${i18nPrefix}.filterGroups.${field.grp}`),
  });
